export default __webpack_public_path__ + "static/media/afonso.f971e65e.mp4";